export var DEFAULT_TOOLTIP_CLASSNAMES = {
    appear: "rmd-tooltip--enter",
    appearActive: "rmd-tooltip--visible",
    enter: "rmd-tooltip--enter",
    enterActive: "rmd-tooltip--visible",
    enterDone: "rmd-tooltip--visible",
    exit: "rmd-tooltip--visible rmd-tooltip--exit",
    exitActive: "rmd-tooltip--exit-active",
};
export var DEFAULT_TOOLTIP_TIMEOUT = {
    enter: 200,
    exit: 150,
};
export var DEFAULT_TOOLTIP_DELAY = 1000;
export var DEFAULT_TOOLTIP_THRESHOLD = 0.75;
/** @remarks \@since 2.8.0 */
export var DEFAULT_TOOLTIP_SPACING = "1.5rem";
/** @remarks \@since 2.8.0 */
export var DEFAULT_TOOLTIP_DENSE_SPACING = "0.875rem";
/** @remarks \@since 2.8.0 */
export var DEFAULT_TOOLTIP_MARGIN = 16;
/** @remarks \@since 2.8.0 */
export var DEFAULT_TOOLTIP_POSITION = "below";
/**
 * @internal
 * @remarks \@since 2.8.0
 */
export var TOOLTIP_SPACING_VAR = "--rmd-tooltip-spacing";
//# sourceMappingURL=constants.js.map